import React from 'react'
import Typography from 'material-ui/Typography'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import { ModalHeader, ModalContents, ModalFooter } from '../../../common/modal'
import Icon from 'material-ui/Icon'

import { withStyles } from 'material-ui/styles'
import styles from './styles'


class UploadDeviceSoftware extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false
    }
    this.state = {
      devicesoftwareupdatefile: null,
      // devicesoftwareupdatereleasenotes: null,
      errors: {

      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.uploadDeviceSoftwareFile = this.uploadDeviceSoftwareFile.bind(this)
  }
  handleChange(e) {
    let errors = { ...this.state.errors }
    if (e.target.type == 'file' && e.target.files.length) {
      let fileExtention = e.target.files[0].name.split('.').pop();
      if (e.target.name === 'devicesoftwareupdatefile' && fileExtention === 'zip') {
        this.setState({
          [e.target.name]: e.target.files[0],
          errors: {
            ...errors,
            [e.target.name]: false
          }
        })
      }
      // else if (e.target.name === 'devicesoftwareupdatereleasenotes' && fileExtention === 'pdf') {
      //   this.setState({
      //     [e.target.name]: e.target.files[0],
      //     errors: {
      //       ...errors,
      //       [e.target.name]: false
      //     }
      //   })
      // }
      else {
        this.setState({
          errors: {
            ...errors,
            [e.target.name]: true
          }
        })
      }
    }
  }
  uploadDeviceSoftwareFile(e) {
    e.preventDefault()
    const { devicesoftwareupdatefile } = this.state

    if (devicesoftwareupdatefile) {
      var fd = new FormData();
      fd.append('softwarefile', devicesoftwareupdatefile)
      fd.append('softwareupdate', devicesoftwareupdatefile.name)
      this.props.uploadDeviceSoftware(fd)
      this.props.onClose()
    }
  }
  render() {
    const { classes, translate, onClose } = this.props
    const { devicesoftwareupdatefile, devicesoftwareupdatereleasenotes, errors } = this.state
    return (
      <Modal open={true} onClose={onClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("settings_device_software_title")}
              </Typography>
               <Button
                className={classes.button}
                onClick={onClose}
              >
              <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={errors.devicesoftwareupdatefile ? true : false}
                >
                  <InputLabel htmlFor="devicesoftwareupdatefile" shrink={true} disableAnimation={true}>{translate("settings_device_software_label")}</InputLabel>
                  <Input
                    className={classes.upload}
                    id="devicesoftwareupdatefile"
                    type="file"
                    name="devicesoftwareupdatefile"
                    onChange={this.handleChange}
                    inputProps={{
                      accept: ".zip",
                      name: "devicesoftwareupdatefile"
                    }}
                  />
                  <FormHelperText id="devicesoftwareupdatefile-helper-text">{translate("settings_device_software_help")}</FormHelperText>
                </FormControl>
                {/* <FormControl
                  margin='normal'
                  fullWidth
                  error={errors.devicesoftwareupdatereleasenotes ? true : false}
                >
                  <InputLabel htmlFor="devicesoftwareupdatereleasenotes" shrink={true} disableAnimation={true}>{translate("settings_devicesoftwareupdatereleasenotes_label")}</InputLabel>
                  <Input
                    id="devicesoftwareupdatereleasenotes"
                    type="file"
                    name="devicesoftwareupdatereleasenotes"
                    onChange={this.handleChange}
                    inputProps={{
                      accept: ".pdf",
                      name: "devicesoftwareupdatereleasenotes"
                    }}
                  />
                  <FormHelperText id="devicesoftwareupdatereleasenotes-helper-text">{translate("settings_device_software_release_notes_help")}</FormHelperText>
                </FormControl> */}
              </form>
            </ModalContents>
            <ModalFooter>
 
              {devicesoftwareupdatefile ? (<Button raised
                color="accent"
                type="submit"
                onClick={this.uploadDeviceSoftwareFile}
              >
                {translate("settings_upload")}
              </Button>) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }

}

export default withStyles(styles)(UploadDeviceSoftware)
